var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13L14.9283 10.4283C14.6158 10.1159 14.1919 9.94036 13.75 9.94036C13.3081 9.94036 12.8842 10.1159 12.5717 10.4283L5 18M4.16667 3H15.8333C16.7538 3 17.5 3.74619 17.5 4.66667V16.3333C17.5 17.2538 16.7538 18 15.8333 18H4.16667C3.24619 18 2.5 17.2538 2.5 16.3333V4.66667C2.5 3.74619 3.24619 3 4.16667 3ZM9.16667 8C9.16667 8.92047 8.42047 9.66667 7.5 9.66667C6.57953 9.66667 5.83333 8.92047 5.83333 8C5.83333 7.07953 6.57953 6.33333 7.5 6.33333C8.42047 6.33333 9.16667 7.07953 9.16667 8Z",
    stroke: "#5763FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.1485bd9c.svg";
export { ForwardRef as ReactComponent };